var map = {
	"./AmiyaBagchi.jpg": 645,
	"./AmiyaBagchi.png": 646,
	"./ChinmayTumbe.png": 647,
	"./DavidArnold.jpg": 648,
	"./DavidArnold.png": 649,
	"./DouglasHaynes.jpg": 650,
	"./DouglasHaynes.png": 651,
	"./DwijendraTripathi.jpg": 652,
	"./DwijendraTripathi.png": 653,
	"./GeoffreyJones.png": 654,
	"./IndiraChowdhury.jpg": 655,
	"./IndiraChowdhury.png": 656,
	"./JosephSassoon.jpg": 657,
	"./JosephSassoon.png": 658,
	"./MedhaKudaisya.jpg": 659,
	"./MedhaKudaisya.png": 660,
	"./MilanBalaban.png": 661,
	"./PrafullAnubhai.jpg": 662,
	"./PrafullAnubhai.png": 663,
	"./RamachandraGuha.png": 664,
	"./RituBirla.jpg": 665,
	"./RituBirla.png": 666,
	"./RobertPerks.png": 667,
	"./RossBassett.jpg": 668,
	"./RossBassett.png": 669,
	"./SusiePak.png": 670,
	"./SvenBeckert.png": 671,
	"./SvenBeckertOld.png": 672,
	"./TirthankarRoy.jpg": 673,
	"./TirthankarRoy.png": 674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 644;